<template>
  <div class="layout">
    <div v-wechat-title="($route.meta.title = docTitle)"></div>
    <searchBar @search="openSearch = true" :theme="1" :placeholder="placeholder"></searchBar>
    <!-- 推荐活动 -->
    <div class="top_wrap" v-if="recommActList&&recommActList.length">
      <Swipe :show-indicators="false" loop :autoplay="5000">
        <SwipeItem v-for="(item, index) in recommActList" :key="'sw-' + index">
          <div @click="LinkAct(item)" class="act-host">
            <div class="my-img">
              <img :src="item.banners[0]" width="100%" style="display: block;height:100%" v-load="'oActBig'" />
            </div>
            <div class="act-info" v-if="item">
              <div class="list">
                <div class="list-title">
                  <p class="title-name">
                    <span class="list-title-txt">{{ item.title }}</span>
                  </p>
                  <span class="my-brand icon dot" v-if="item.hasLive && item.liveAuditState === 'PASS' && item.liveStateIndex == 1">
                    Live
                  </span>
                  <!-- <span class="my-brand icon s-blue" v-if="item.hasLive && item.liveAuditState === 'PASS' && item.liveStateIndex == 2">
                    <span class="icon iconfont icon-zhibo"></span>有直播
                  </span> -->
                  <!-- <span class="my-brand s-gray" v-if="exActList.hasLive && exActList.liveAuditState === 'PASS' && exActList.liveStateIndex == 3 ">
                    直播回看
                  </span> -->
                  <span class="list-title-txt2">{{ item.startTime }}</span>
                </div>
                <div class="list-main z-padd">
                  <div class="brand">
                    <span>
                      <i class="icon iconfont icon-fenxiang2"></i>
                      {{ item.shareCount }}
                    </span>
                  </div>
                  <div class="brand">
                    <span>
                      <i class="icon iconfont icon-guankan2"></i>
                      {{ item.viewCount }}
                    </span>
                  </div>
                  <div class="brand">
                    <span>
                      <i class="icon iconfont icon-zhuce3"></i>
                      {{ item.followCount }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwipeItem>
      </Swipe>
    </div>
    <!-- <div v-if="exActList" @click="LinkAct(exActList)" class="act-host">
      <Swipe :autoplay="3000">
        <SwipeItem v-for="(image, index) in banner" :key="'sw-' + index">
          <img
            :src="image"
            width="100%"
            style="display: block; height: 100%"
            v-load="'oActBig'"
          />
        </SwipeItem>
      </Swipe>
      <div class="act-info" v-if="exActList">
        <div class="list">
          <p class="list-title">
            <span class="list-title-txt">{{ exActList.titleEn  }}</span>
            <span
              class="my-brand icon dot"
              v-if="
                exActList.hasLive &&
                exActList.liveAuditState === 'PASS' &&
                exActList.liveStateIndex == 1
              "
            >
              Live
            </span>
            <span class="list-title-txt2">{{
              exActList.startTime | moment("MM/DD HH:mm")
            }}</span>
          </p>
          <div class="list-main z-padd">
            <div class="brand">
              <span>
                <i class="icon iconfont icon-fenxiang2"></i>
                {{ exActList.shareCount }}
              </span>
            </div>
            <div class="brand">
              <span>
                <i class="icon iconfont icon-guankan2"></i>
                {{ exActList.viewCount }}
              </span>
            </div>
            <div class="brand">
              <span>
                <i class="icon iconfont icon-zhuce3"></i>
                {{ exActList.followCount }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 展商活动分类 -->
    <more ref="more"></more>

    <layoutFooter></layoutFooter>
    <!-- 侧边栏 -->
    <exTool :isZT="false" :isZX="false" :isLive="true" @toolTouch="toolTouch"></exTool>

    <!-- 热门搜索 -->
    <searchPage :show="openSearch" :placeholder="placeholder" :type="rankingType" @callback="setSearch" ref="search"></searchPage>

    <!-- 申请热榜，直播 -->
    <hot ref="hot"></hot>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Swipe, SwipeItem } from "vant";
import layoutFooter from "@components/layout-footer";
import searchBar from "@components/searchBar/index";
import exTool from "../home/components/ex-tool";
import searchPage from "@/components/searchPage"; // 搜索页
import more from "./components/more";
import { formatTime } from "../../utils/utils";
import gql from "graphql-tag";
import hot from "../live/components/goHot";
import moment from "moment";
export default {
  name: "activity",
  data () {
    return {
      openSearch: false,
      exActList: null,
      recommActList: [], //推荐活动
      banner: [],
      docTitle: "Activity",

      rankingType: "CompInfo", // 默认显示展商
      searchType: 0, // 搜索类型
      placeholder: "Activitys",
      shareV: {
        content: "",
        poster: "",
      },
    };
  },
  components: {
    Swipe,
    SwipeItem,
    layoutFooter,
    searchBar,
    more,
    exTool,
    searchPage,
    hot,
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      exhibitionInfo: "getExhibitionInfo",
      userId: "getUserId",
    }),
    ExLive () {
      return gql`
        query getActivityExhibitions($exhibitionId: Guid!) {
          getActivityExhibitions(exhibitionId: $exhibitionId) {
            acvitityType
            banners
            createAt
            endTime
            exhibitionId
            exhibitorId
            externalLink
            followCount
            id
            likeCount
            shareCount
            startTime
            stateIndex
            title
            titleEn
            userCount
            videos
            liveAuditState
            hasLive
            liveStateIndex
            auditState
            viewCount
          }
        }
      `;
    },
  },
  created () {
    this.init();
    this.$Myapollo.addExhibitionView();
  },
  methods: {
    ...mapActions({
      LinkAct: "linkTo/LinkAct",
      shareToWechat: "wxShare/shareToWechat",
      getSettingShare: "wxShare/getSettingShare", //分享配置展会
      graphqlPost: "en/graphqlPostByZXS", //阿波罗接口方法
    }),
    async init () {
      let exhibitionId = this.$route.params.id;
      this.$store.commit("setExhibitionId", exhibitionId);
      await this.$Myapollo.getExhibitionInfo(
        this,
        this.exhibitionId,
        this.userId
      );
      if (this.exhibitionInfo && this.exhibitionInfo.exhibition) {
        this.docTitle = this.exhibitionInfo.exhibition.nameEn || "Activity";
      }
      // this.getExAct();
      //推荐的活动
      this.getCommAct();
      // 分享的配置
      await this.getShareVal();
      const opt = {
        title: this.shareV.content
          ? this.shareV.content
          : "诚邀您参观 " + this.exhibitionInfo.exhibition.name + " 线上展",
        desc: this.shareV.des || this.exhibitionInfo.exhibition.remark,
        link: window.location.href,
        imgUrl: this.exhibitionInfo.exhibition.logo,
      };
      this.shareToWechat(opt);
    },
    // 获取展会的分享配置
    async getShareVal () {
      let res = await this.getSettingShare({
        id: this.exhibitionId,
        name: "share.exhibition.config",
      });
      if (res) {
        this.shareV = JSON.parse(res);
      }
      this.isShareV = true;
    },
    //获取推荐的活动
    async getCommAct () {
      let query = `
       query activityQuery($where:_Any!,$orders:[_Any]){
            activityQuery{
              find(where: $where,orders:$orders){
                acvitityType
                banners
                company{
                  name
                }
                exhibitionId
                exhibitorId
                externalLink
                followCount
                id
                likeCount
                shareCount
                startTime
                endTime
                stateIndex
                title
                userCount
                liveAuditState
                hasLive
                liveStateIndex
                auditState
                topic
                topicIndex
                viewCount
              }
            }
          }
      `;
      let where = {
        Equal: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        Equal3: {
          n: "isShow",
          v: 1,
        },
        greaterThan_topic: {
          n: "topic",
          v: 0,
        },
      };
      let order = [
        { n: "Topic", v: 0 },
        { n: "TopicIndex", v: 0 },
        { n: "StateIndex" },
        { n: "CreateAt", v: 0 },
      ];
      let opt = {
        query: query,
        variables: {
          where: where,
          orders: order,
        },
      };
      let data = await this.graphqlPost(opt);
      let res = JSON.parse(JSON.stringify(data.data.activityQuery.find));
      if (res && res.length) {
        res.map((c) => {
          if (c.banners && c.banners.search(/^\[/) !== -1) {
            c.banners = JSON.parse(c.banners);
          } else {
            c.banners = [c.banners];
          }
          c.startTime.replace(/-/g, "/");
          c.startTime = moment(c.startTime).format("MM/DD HH:mm");
        });
      }
      this.recommActList = res || [];
      console.log(this.recommActList, "哈哈");
    },
    getExAct () {
      this.$apollo.addSmartQuery("getActivityExhibitions", {
        query: this.ExLive,
        variables: {
          exhibitionId: this.exhibitionId,
        },
        result (res) {
          console.log(res, "ressss");
          if (res.data.getActivityExhibitions) {
            let actIng = res.data.getActivityExhibitions.filter(
              (c) => c.hasLive === true && c.liveStateIndex === 1
            ); // 正在进行的活动
            let actBefore = res.data.getActivityExhibitions.filter(
              (c) => c.hasLive === true && c.liveStateIndex === 2
            ); // 未开始
            let actOver = res.data.getActivityExhibitions.filter(
              (c) => c.hasLive === true && c.liveStateIndex === 3
            ); //已结束
            actBefore.sort(function (a, b) {
              return (
                Date.parse(b.startTime.replace(/-/g, "/")) -
                Date.parse(a.startTime.replace(/-/g, "/"))
              );
            });
            actOver.sort(function (a, b) {
              return (
                Date.parse(b.startTime.replace(/-/g, "/")) -
                Date.parse(a.startTime.replace(/-/g, "/"))
              );
            });
            if (actIng.length) {
              this.exActList = actIng[0];
            } else {
              if (actBefore.length) {
                this.exActList = actBefore.reverse()[0];
              } else {
                if (actOver.length) {
                  this.exActList = actOver[0];
                }
              }
            }
            const Today = formatTime(new Date()).slice(0, 11);
            res.data.getActivityExhibitions.forEach((c) => {
              let Time = c.startTime.slice(0, 11).replace(/-/g, "/");
              if (Today == Time) {
                this.exActList = c;
              }
            });
            console.log(this.exActList, "展会活动数据");
            if (this.exActList) {
              if (this.exActList.banners.indexOf("[") !== -1) {
                this.banner = JSON.parse(this.exActList.banners);
              } else {
                this.banner = [this.exActList.banners];
              }
            }
          }
        }, // 错误处理
        error (error) {
          console.error(error, "error错误处理");
        },
      });
    },
    // 比较时间
    compareDate (statedate, enddate) {
      const stateTime = new Date(statedate).getTime();
      const Time = new Date().getTime();
      const endTime = new Date(enddate).getTime();
      if (stateTime < Time && Time < endTime) {
        return 1; //进行中
      } else if (endTime < Time) {
        return 2; //已结束
      } else {
        return 3; //未开始
      }
    },
    setSearch (e) {
      // 设置搜索值 
      this.openSearch = false;
      this.searchText = e.txt;
      this.searchType = e.type; // 0为输入搜索，1为展馆，2为类别
      this.$store.commit("setSearch", this.searchText);
    },
    toolTouch (type) {
      if (type === "live") {
        // 上直播
        this.$refs["hot"].open("上直播");
      }
    },
  },
  beforeDestroy () {
    console.log("actvity:destroyed");
    if (this.$refs["more"]) {
      this.$refs["more"].reset();
    }
  },
};
</script>

<style lang="scss" scoped>
.layout {
  padding-top: 0.93rem;
}
.top_wrap {
  width: 100%;
  height: 5.73rem;
  .my-swiper {
    width: 100%;
    height: 100%;
  }
}
.act-info {
  .list {
    flex-direction: column;
    padding: 10px 15px;
    background: #fff;
    &-title {
      font-weight: 600;
      font-size: 16px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      width: 100%;
      justify-content: space-between;
      .my-brand {
        line-height: initial;
        width: 0.88rem;
        height: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-blend-mode: normal, normal;
        border-radius: 0.05rem;
        color: #fff;
        font-size: 0.18rem;
        vertical-align: middle;
        margin-right: 4px;
      }
      .dot {
        background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
          linear-gradient(#000, #000);
      }
      .s-gray {
        background-image: linear-gradient(90deg, #ffc659 0%, #ffa751 100%),
          linear-gradient(#bfbfbf, #bfbfbf);
      }
      // &-txt {
      //   display: inline-block;
      //   max-width: 150px;
      //   overflow: hidden;
      //   white-space: nowrap;
      //   text-overflow: ellipsis;
      //   // margin-right: 10px;
      //   font-size: 15px;
      //   color: #333;
      //   min-height: 0.34rem;
      // }
      // &-txt2 {
      //   flex: 1;
      //   font-size: 12px;
      //   color: #666;
      //   text-align: right;
      // }
      .title-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &-txt {
        font-size: 15px;
        color: #333;
      }
      &-txt2 {
        flex: none;
        font-size: 12px;
        color: #666;
        text-align: right;
        margin-left: 0.05rem;
        display: block;
      }
    }
    &-main {
      display: flex;
      align-items: center;
      font-size: 12px;
      margin-top: 8px;
      color: rgb(102, 102, 102);
      position: relative;
      left: -3px;
      .brand {
        line-height: 1.2;
        margin-right: 8px;
        font-size: 0.22rem;
        &.z-right {
          justify-self: flex-end;
          flex: 1;
          span {
            display: inline-block;
            width: 100%;
            text-align: right;
          }
        }
        span {
          color: #999;
          line-height: 18px;
          display: inline-block;
          display: flex;
          align-items: center;
          font-size: 0.24rem;
          .icon-dianzan,
          .icon-guanzhu {
            font-size: 0.36rem;
          }
          .icon-zhiboguankanshu {
            position: relative;
            top: 1px;
          }
          .icon-guanzhu {
            position: relative;
            top: -1px;
          }
        }
        .iconfont {
          font-size: 0.36rem;
          display: inline-block;
        }
      }
      &.z-padd {
        margin: 2px 0 0 0;
      }
      .ranking-conten-guanKan {
        display: inline-block;
        width: 16px;
        height: 14px;
        position: relative;
        top: 3px;
        margin-right: 2px;
      }
      .rc-border {
        border: 1px solid rgb(230, 230, 230);
        border-radius: 2px;
        margin-right: 5px;
        padding: 1px 2px;
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        line-height: 1.2;
        .icon {
          font-size: 12px;
          position: relative;
          left: 1px;
        }
        span {
          position: relative;
          left: -2px;
        }
        &.z-padd {
          padding: 1px 3px 1px 0;
        }
      }
    }
  }
}
.top_wrap .my-img {
  height: 4.23rem;
}
</style>